{-
Copyright 2016 SlamData, Inc.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
-}

module Matryoshka.Util where

import Prelude

import Matryoshka.Class.Corecursive (class Corecursive, embed)
import Matryoshka.Class.Recursive (class Recursive, project)

mapR :: forall t f u g. Recursive t f => Corecursive u g => (f t -> g u) -> t -> u
mapR f = embed <<< f <<< project

traverseR
  :: forall t f u g m
   . Recursive t f
  => Corecursive u g
  => Functor m
  => (f t -> m (g u))
  -> t
  -> m u
traverseR f = map embed <<< f <<< project
